// app.component.ts
import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { TranslationService } from './services/translation';
import { TranslatePipe } from './pipes/translate.pipe';
import { GlobalToastComponent } from './shared/components/global-toast/global-toast.component';
import { HealthMonitoringService } from './core/services/health-monitoring.service';
import { ConnectionOverlayComponent } from './core/layouts/connection-overlay/connection-overlay.component';
import { CommonModule } from '@angular/common';

// PrimeNG Imports (standalone)
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    ButtonModule,
    CardModule,
    TableModule,
    ToastModule,
    ProgressSpinnerModule,
    RouterOutlet,
    GlobalToastComponent,
    ConnectionOverlayComponent,
    CommonModule,
  ],
  providers: [MessageService], // Required for Toast
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  version = '20.0.0';
  primengVersion = '21.0.2';

  constructor(
    private translationService: TranslationService,
    private messageService: MessageService,
    public healthService: HealthMonitoringService
  ) {}

  switchLanguage() {
    this.translationService.switchLanguage();
  }

  showToast() {
    this.messageService.add({
      severity: 'success',
      summary: this.translationService.translate('successSummary'),
      detail: this.translationService.translate('successDetail'),
    });
  }
}
